import React, {useContext, useEffect, useState} from 'react';
import { handleEmailPasswordSignIn } from '../Utils.ts';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import {useAppStore} from "../../../../GlobalStore/GlobalStore.ts";
import {useParams} from "react-router-dom";
import {GlobalContext} from "../../../../App.tsx";

interface SignInFormProps {
    isSignUp: boolean;
    closeModal: any;
}

const SignInForm: React.FC<SignInFormProps> = ({ isSignUp, closeModal }) => {
    const { uuid } = useParams<{ uuid: string }>();

    const { messagesSequenceRef } = useContext(GlobalContext);
    const setUserObj = useAppStore((state: any) => state.setUserObj);
    const setDynamicStateObj = useAppStore((state: any) => state.setDynamicStateObj);
    const updateChatHistory = useAppStore((state: any) => state.updateChatHistory);
    const environmentObj = useAppStore((state: any) => state.environmentObj);
    const { environment, vscode } = environmentObj;
    const dynamicStateObj = useAppStore((state: any) => state.dynamicStateObj);
    const { shareMessagesSequence, shareChatName } = dynamicStateObj;

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [notification, setNotification] = useState<{ message: string, type: string } | null>(null);
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        setNotification(null);
    }, [isSignUp]);

    return (
        <form className="space-y-4" onSubmit={(e) => handleEmailPasswordSignIn(e, isSignUp, email, password, closeModal, setNotification, environment, vscode, setUserObj, setDynamicStateObj, messagesSequenceRef, shareMessagesSequence, shareChatName, updateChatHistory, uuid )}>
            <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="text-black w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-cyan-500"
            />
            <div className="relative">
                <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="text-black w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-cyan-500"
                />
                <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-600 bg-transparent"
                >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
            </div>
            {notification && (
                <p className={`text-${notification.type === 'error' ? 'red' : 'green'}-500`}>
                    {notification.message}
                </p>
            )}
            <button type="submit" className="w-full bg-cyan-800 text-white p-3 rounded-md hover:bg-cyan-700 transition duration-300 ease-in-out">
                {isSignUp ? 'Sign Up' : 'Sign In'}
            </button>
        </form>
    );
};

export default SignInForm;
